import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { Skeleton } from '@jira/platform__periscope/src/ui/skeleton/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwarePeriscopeClassicRoute } from '@jira/router-routes__software-periscope-routes/src/softwarePeriscopeClassicRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { fg } from '@atlassian/jira-feature-gating';
import { GSNPeriscopeEntryPoint, periscopeEntryPoint } from './common/periscope.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwarePeriscopeClassicRouteEntry: Route = createEntry(
	softwarePeriscopeClassicRoute,
	() => ({
		group: 'classic-software',
		skeleton: Skeleton,
		resources: [
			...getNavigationResources({ isUsingSidebarEntrypoint: true }),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			rovoEntitlementResource,
		],
		layout: classicSoftwareProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
			sidebarId: SidebarIdContent,
		},
		entryPoint: () => {
			if (isFedRamp()) {
				// JOLT-2765: FedRAMP tenants are blocked from Periscope by default.
				// The kill-switch gate enables an AEM allowlist check that lets
				// individual FedRAMP tenants opt in.
				if (!fg('jira_development_enable_aem_fedramp_check')) {
					return notFoundPageEntrypoint;
				}
				if (!isFeatureEnabled('jira', 'jira-development-tab')) {
					return notFoundPageEntrypoint;
				}
			}
			if (fg('navx-global-side-nav')) {
				return GSNPeriscopeEntryPoint;
			}
			return periscopeEntryPoint;
		},
		meta: {
			reporting: {
				id: 'software-periscope-classic',
				packageName: camelCase('software-periscope-classic'),
				teamName: 'jolt',
			},
		},
		supportsPreviewPanel: true,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
